import React from 'react';

type BusyOverlayProps = {
    isLoading: boolean;
    isSaving: boolean;
};

const BusyOverlay: React.FC<BusyOverlayProps> = ({ isLoading, isSaving }) => {
    if (!isLoading && !isSaving) {
        return null;
    }

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 5
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px 18px',
                    borderRadius: '8px',
                    backgroundColor: '#2667c2ff',
                    color: 'white',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                }}
            >
                <span style={{ fontSize: '20px' }}>
                    {isSaving ? '💾' : '⏳'}
                </span>
                <span>{isSaving ? 'Saving annotations...' : 'Loading ...'}</span>
            </div>
        </div>
    );
};

export default BusyOverlay;
